


























































 import VueFramework from 'vue'
 import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
 import {
     CreateOrUpdateTopicResponse,
     CreateTopic, Post,
     Topic,
     UpdateTopic
 } from "../../repository/messagehub.dtos";

 import {AxiosResponse} from "axios";
 import * as channelRecord from "../../store/Channel/ChannelRecord";
// import * as topicRecord from "@/store/Topic/TopicRecord";
 import * as topicRecord from "../../store/Topic/TopicRecord"
 import * as postRecord from "../../store/Posts/PostRecord"
 import {TopicApi} from "../../repository/TopicApi";
 import {PostsApi} from "../../repository/PostsApi";

 @Component({
     components: {


     },
     name: 'TopicComponent',
 })
 export default class TopicComponent extends Vue{

     postsApi: PostsApi = new PostsApi()
     isDeleteTopicMobalVisible: boolean = false
     topicApi: TopicApi = new TopicApi()
     topicContentWarning: boolean = false
     topicTitle: string = ''
     editTopicTitle: string = ''
     htmlText:string = ""
     topicErrrorContent: string = ''

     get selectedChannel(){
         return channelRecord.getSelectedChannel(this.$store)
     }
     get topics(){
         let topics = topicRecord.getTopics(this.$store)
         if (!topics){
             return []
         }
         else{
             return topics
         }
     }
     set selectedTopic(topic: Topic){
         topicRecord.selectedTopicChanged(this.$store, <Topic>topic)
     }
     get selectedTopic(){
         return topicRecord.getSelectedTopic(this.$store)
     }
     onChannelMenuCommandClick(item: any){
         if (item.id ==0){
             console.log('channel edit commmand')
         }
         else if (item.id ==1){
             this.$emit('onShowDeleteModalEvent')

         }
     }
     async onCreateTopic(){
         console.log(this.selectedChannel)
         let newTopic = new CreateTopic(this.topicTitle, true, this.selectedChannel.id)

         try {

             let response:AxiosResponse = await this.topicApi.createTopic(newTopic)
             if (response.status === 200){
                 this.editTopicTitle = this.topicTitle
                 this.topicTitle = ''
                 topicRecord.addTopic(this.$store, <Topic> response.data.data)
             }
         }
         catch (e) {
             console.log(e)
         }
     }


     async setItemAndGetPosts(item:any){
         this.$emit('onShowPostCreator', false)
         topicRecord.selectedTopicChanged(this.$store, <Topic>item)

     }
     data () {
         return {
             channelMenu: [
                 /*{
                     id: 0,
                     description: "Edit Channel"
                 },*/
                 {
                     id: 1,
                     description: "Delete Channel"
                 }
             ],

             createChannelDialog: false,

         }
     }
 }
